import React, { Component } from 'react'
import PropTypes from 'prop-types'
import compose from '@shopify/react-compose'
import { withTranslation } from 'react-i18next'

import RanView from './ran-view'
import RanActivate from './ran-activate'

import { withConfiguration, withEndUser, AppLoader, FormError } from '@portal/kit/pkg/components'
import { withRan } from 'components/providers/ran'

class RanContainer extends Component {
  state = {
    activationRequested: false,
  }

  ranActivated = () => {
    const rooms = this.props.getRooms()
    return rooms && rooms.length > 0
  }

  activateRan = () => {
    const canActivateRan = this.props.canActivateRan()

    if (!canActivateRan) return
    this.setState({ activationRequested: true })
  }

  refreshRooms = () => this.props.loadRanRooms()

  render() {
    const rooms = this.props.getRooms()
    const canActivateRan = this.props.canActivateRan()
    const isFetching = this.props.isFetching()

    if (this.state.globalError) {
      return <FormError message={this.state.globalError} />
    }

    if (isFetching) {
      return <AppLoader />
    }

    if (rooms.length === 0 || this.state.activationRequested) {
      return <RanActivate autoStart={this.state.activationRequested} refreshRooms={this.refreshRooms} />
    }

    return (
      <RanView
        {...this.props}
        rooms={rooms}
        canActivateRan={canActivateRan}
        ranActivated={this.ranActivated()}
        activateRan={this.activateRan}
      />
    )
  }

}

RanContainer.propTypes = {
  portalConfiguration: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
}

export default compose(
  withConfiguration,
  withEndUser,
  withRan,
  withTranslation(),
)(RanContainer)
